import {PortalType} from "@studyportals/domain-client";
import {useRuntimeConfig, useState} from "nuxt/app";

export const getPortalTypeFromEnvClient = (): PortalType => {
	let portalTypeFromState: string | undefined;
	if (typeof useState === 'function') {
		try {
			portalTypeFromState = useState<{ portalType?: string } | null>('portalConfig').value?.portalType;
		} catch {
			portalTypeFromState = undefined;
		}
	}

	const runtimeConfig = useRuntimeConfig();
	const portalTypeStr = portalTypeFromState || (runtimeConfig.public.portalType as string) || 'master';

	const portalTypeMap: Record<string, PortalType> = {
		'master': PortalType.MASTER,
		'bachelor': PortalType.BACHELOR,
		'phd': PortalType.PHD,
		'short': PortalType.SHORT,
		'distance_learning': PortalType.DISTANCE_LEARNING,
	};

	return portalTypeMap[portalTypeStr.toLowerCase()] || PortalType.MASTER;
};
